// extracted by mini-css-extract-plugin
module.exports = {"embeddedWrapper":"videoEmbed_embeddedWrapper__3aMJJ","playerWrapper":"videoEmbed_playerWrapper__l9QM8"};